import { render, staticRenderFns } from "./LoginImageView.vue?vue&type=template&id=04bd3572&scoped=true&"
import script from "./LoginImageView.vue?vue&type=script&lang=js&"
export * from "./LoginImageView.vue?vue&type=script&lang=js&"
import style0 from "./LoginImageView.vue?vue&type=style&index=0&id=04bd3572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd3572",
  null
  
)

export default component.exports